import Litepicker from 'litepicker'

export default function () {
	const form                = document.querySelector( 'form' );
	if ( ! form) {
		return
	}
	const topicsFormSelect = document.querySelectorAll('select[name="menu-topics"]');
	if(topicsFormSelect) {
		topicsFormSelect.forEach(function (select) {

			select.innerHTML = '';

			if(localize_form.topics.length > 0) {
				localize_form.topics.forEach(function (topic) {
					const option = document.createElement('option');
					option.value = topic.temat_rozmowy;
					option.innerText = topic.temat_rozmowy;
					select.appendChild(option)
				})
			}
		})
	}

	const districtsFormSelect = document.querySelectorAll('select[name="district"]');
	if(districtsFormSelect) {
		districtsFormSelect.forEach(function (select) {
			if(localize_form.districts.length > 0) {
				localize_form.districts.forEach(function (topic) {
					const option = document.createElement('option');
					option.value = topic.temat_rozmowy;
					option.innerText = topic.temat_rozmowy;
					select.appendChild(option)
				})
			}
		})
	}

	const selects             = form.querySelectorAll( 'select' );
	const svgArrow            = '<svg width="5px" height="8px" viewBox="0 0 5 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>arrow</title><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="Menu" transform="translate(-1567.000000, -35.000000)" stroke="#FFFFFF" stroke-width="2"><g id="Group-2" transform="translate(1407.000000, 24.000000)"><polyline id="arrow" transform="translate(162.500000, 15.000000) rotate(-90.000000) translate(-162.500000, -15.000000) " points="159.5 13.5 162.5 16.5 165.5 13.5"></polyline></g></g></g></svg>';
	const svgUpload           = '<?xml version="1.0" ?><svg fill="white" enable-background="new 0 0 500 500" id="Layer_1" version="1.1" viewBox="0 0 500 500" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><g><path d="M386.9,401.1H113.1c-45.3,0-82.1-36.8-82.1-82.1c0-36.8,24.4-68.7,59.2-78.7c8.3-22.5,27.7-38.8,51-43.2    c6.2-54.5,52.6-97,108.8-97c44.7,0,85,27.7,101.5,68.6c48.1,2.8,86.7,41.3,89.9,89.3c17.6,15.6,27.6,37.5,27.6,61.1    C469,364.2,432.2,401.1,386.9,401.1z M154.2,223.1c-19.1,0-35.5,13-39.9,31.7l-2,8.8l-8.9,1.6c-26.1,4.7-45,27.3-45,53.7    c0,30.2,24.6,54.8,54.8,54.8h273.8c30.2,0,54.8-24.6,54.8-54.8c0-17.1-8-33-21.9-43.5l-5.4-4.1l0-7.9c0-37-30.7-67.7-68.5-67.7    l-14,0.7l-3.1-10.3c-10.2-34.6-42.6-58.8-78.7-58.8c-45.3,0-82.1,36.8-82.1,82.1v13.7H154.2z"/></g><g><rect height="117.3" width="27.4" x="236.3" y="229"/></g><g><polygon points="295.1,287.6 250,242.5 204.9,287.6 185.6,268.2 250,203.8 314.4,268.2   "/></g></g></svg>';
	const litepickerContainer = document.getElementById( 'litepicker' );
	if (litepickerContainer) {
		const picker = new Litepicker(
			{
				element: litepickerContainer
			}
		);
	}
	const multipleFileBtn = document.querySelectorAll( '.qbutton' );
	multipleFileBtn.forEach(
		function (el) {
			const multipleFileBtnWrapper = document.createElement( 'div' );
			const uploadFileIcon         = document.createElement( 'div' );
			multipleFileBtnWrapper.classList.add( 'form__multiple-file' )
			uploadFileIcon.classList.add( 'upload-icon' );
			uploadFileIcon.innerHTML = svgUpload;

			el.parentNode.insertBefore( multipleFileBtnWrapper, el )
			multipleFileBtnWrapper.appendChild( el )
			multipleFileBtnWrapper.appendChild( uploadFileIcon )

		}
	)
	selects.forEach(
		function (select) {
			select.style.display = 'none';
			let newSelect        = document.createElement( 'div' );
			let selectedItem     = document.createElement( 'div' );
			let selectOptions    = document.createElement( 'div' );
			let options          = select.querySelectorAll( 'option' );
			let chevron          = document.createElement( 'div' );
			newSelect.classList.add( 'form__select' );
			selectedItem.classList.add( 'form__select__selected' );
			selectOptions.classList.add( 'form__select__options' );
			select.parentElement.appendChild( newSelect );
			newSelect.appendChild( selectedItem );
			newSelect.appendChild( selectOptions );
			chevron.innerHTML = svgArrow;
			chevron.classList.add( 'chevron__arrow' )
			newSelect.appendChild( chevron )

			newSelect.addEventListener(
				'click',
				function () {
					if (this.classList.contains( 'active' )) {
						this.classList.remove( 'active' )
					} else {
						this.classList.add( 'active' )
					}
				}
			)
			document.addEventListener(
				'click',
				function (e) {
					if (e.target !== newSelect) {
						newSelect.classList.remove( 'active' )
					}
				}
			)

			options.forEach(
				function (option, index) {
					let newOption = document.createElement( 'div' );
					newOption.classList.add( 'form__select__option' );
					newOption.setAttribute( 'value',option.getAttribute( 'value' ) );
					newOption.setAttribute( 'value',option.getAttribute( 'value' ) );
					newOption.innerText = option.innerText
					selectOptions.appendChild( newOption );
					if (index === 0) {
						selectedItem.innerText = option.innerText
						newOption.setAttribute( 'disabled','' )
					}

					newOption.addEventListener(
						'click',
						function () {
							if (this.getAttribute( 'disabled' ) === null) {
								option.setAttribute( 'selected', true );
								selectedItem.innerText = this.innerText
								select.dispatchEvent( new Event( 'change' ) );
							}
						}
					)
				}
			)

		}
	)

	let ele = form.querySelectorAll( '.wpcf7-numbers-only' );
	ele.forEach(
		function (el) {
			if (el.getAttribute( 'name' ) == 'email-repeat') {
				el.onpaste = function(e){
					e.preventDefault();
				}
			}
			if (el.getAttribute( 'name' ) == 'pesel') {
				let max_chars = 10;
				el.onkeypress = function(e) {
					if ( isNaN( this.value + "" + String.fromCharCode( e.charCode ) ) ) {
						return false;
					}
					if (el.value.length > max_chars) {
						el.value = el.value.substr( 0, max_chars );
					}
				}
				el.onpaste    = function(e){
					e.preventDefault();
				}
			}
		}
	)
	const submitButtonWrapper = document.querySelector('.form-submit__wrapper');
	if( submitButtonWrapper ) {
		const buttonArrow = document.createElement('div');
		buttonArrow.innerHTML = svgArrow;
		buttonArrow.classList.add('button__chevron')
		submitButtonWrapper.appendChild(buttonArrow)
	}


	var wpcf7Elm = document.querySelector( '.wpcf7' );

	if( wpcf7Elm ) {
		wpcf7Elm.addEventListener( 'wpcf7submit', function( event ) {
			setTimeout(() => {
				document.querySelector('.wpcf7-response-output').scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
			}, 450)
		}, false );
	}

}
